import React, { useState } from 'react';
import Layout from 'components/sales/layout/layout';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import localization from 'assets/localization/localization';
import { toast } from 'react-toastify';
import Regex from 'services/utils/regex/Regex';
import {
  INITIAL_FORM_VALUES,
  PROPERTY_TYPE_OPTIONS,
} from './constants';
import './valetReferral.css';

const ValetReferralForm = ({ createEmployeeClientReferral }) => {
  const [formData, setFormData] = useState(INITIAL_FORM_VALUES);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const setField = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const validate = () => {
    if (!String(formData.name || '').trim()) {
      toast.warning('Name is required');
      return false;
    }
    const phone = String(formData.phone_number || '').trim();
    if (!phone || !Regex.phoneNumber.test(phone) || phone.length !== 10) {
      toast.warning(localization.phoneError);
      return false;
    }
    const email = String(formData.email_id || '').trim();
    if (email && !Regex.email.test(email)) {
      toast.warning(localization.emailError);
      return false;
    }
    if (!String(formData.property_name || '').trim()) {
      toast.warning('Property name is required');
      return false;
    }
    if (!formData.property_type?.id) {
      toast.warning('Property type is required');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setIsSubmitting(true);
    try {
      await createEmployeeClientReferral({
        ...formData,
        property_type: formData.property_type.id,
      });
      toast.success('Lead referred successfully. Our team will get in touch shortly.');
      setFormData(INITIAL_FORM_VALUES);
    } catch (err) {
      toast.error(err?.message || 'Failed to create referral');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Layout title={localization.valetReferral} isGoback useNewHeaderLayout>
      <form className="valet-referral-form" onSubmit={handleSubmit}>
        <div className="row valet-referral-form__fields">
          <div className="col-12 col-lg-4 valet-referral-form__field">
            <ConstantInput
              label="Name"
              type="text"
              value={formData.name}
              handleChange={(val) => setField('name', val)}
              required
              isStarRequired
              fullWidth
            />
          </div>
          <div className="col-12 col-lg-4 valet-referral-form__field">
            <ConstantInput
              label="Phone Number"
              type="number"
              value={formData.phone_number}
              handleChange={(val) => setField('phone_number', val)}
              regex={Regex.phoneNumber.test(formData.phone_number)}
              errorMsg={localization.numericError}
              maxLength={10}
              minLength={10}
              tenDigitsValidation={true}
              checkDigits={true}
              required
              isStarRequired
              fullWidth
            />
          </div>
          <div className="col-12 col-lg-4 valet-referral-form__field">
            <ConstantInput
              label="Email"
              type="email"
              value={formData.email_id}
              handleChange={(val) => setField('email_id', val)}
              regex={formData.email_id ? Regex.email.test(formData.email_id) : null}
              errorMsg={localization.emailError}
              fullWidth
            />
          </div>
          <div className="col-12 col-lg-4 valet-referral-form__field">
            <ConstantInput
              label="Property Name"
              type="text"
              value={formData.property_name}
              handleChange={(val) => setField('property_name', val)}
              required
              isStarRequired
              fullWidth
            />
          </div>
          <div className="col-12 col-lg-4 valet-referral-form__field">
            <DropDownInput
              label="Type"
              data={PROPERTY_TYPE_OPTIONS}
              value={formData.property_type?.name || ''}
              getIdValue={(val) => setField('property_type', val)}
              isStarRequired
              required
            />
          </div>
          <div className="col-12 valet-referral-form__field valet-referral-form__field--full">
            <TextAreaInput
              label="Remark"
              rows={3}
              value={formData.remark}
              inputValue={formData.remark}
              className={formData.remark?.trim() ? '' : 'empty'}
              handleChange={(e) => setField('remark', e.target.value)}
            />
          </div>
        </div>
        <div className="valet-referral-form__actions">
          <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </button>
        </div>
      </form>
    </Layout>
  );
};

export default ValetReferralForm;
